export enum IdentityEnum {
  NO_FACE_DETECT = "NO_FACE_DETECT",
  WIDTH_NOT_MATCH_MINWIDTH = "WIDTH_NOT_MATCH_MINWIDTH",
  HEIGHT_NOT_MATCH_MINHEIGHT = "HEIGHT_NOT_MATCH_MINHEIGHT",
  IMAGE_RESOLUTION = "IMAGE_RESOLUTION",
  HORIZONTALDPI = "HORIZONTALDPI",
  IMAGE_ROTATION = "IMAGE_ROTATION",
}
